import API from "../../Api/Api.js";
import { productUrlRewrite } from "../../utils/utils.js";
import { closeModal } from "./confirmationModal.js";
import { handleError, handleInfo } from "./notifications.js";
import qs from "qs";
const token = localStorage.getItem("token");

export const getAllProducts = (filter) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  const query = qs.stringify(
    {
      filters: {
        name: {
          $containsi: filter,
        },
      },
      populate: {
        image: {
          populate: {
            url: "*",
          },
        },
        image2: {
          populate: {
            url: "*",
          },
        },
      },
      sort: ["createdAt:desc"],
    },

    {
      encodeValuesOnly: true,
    }
  );
  dispatch({ type: "PRODUCTS_LOADING" });
  try {
    let { data } = await API.get("api/products?" + query);
    dispatch({ type: "FETCH_PRODUCTS", payload: data.data });
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};

export const deleteProduct = (id) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  dispatch({ type: "PRODUCTS_LOADING" });
  try {
    await API.delete(`api/products/${id}`);
    dispatch(getAllProducts());
    dispatch(handleInfo("Product deleted", 1));
    dispatch(closeModal());
  } catch (error) {
    dispatch(handleError("Error while deleting the product", 1));
    console.log(error);
  }
};

export const getProductItem = (id, noLoading) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  const query = qs.stringify(
    {
      filters: { id: { $eq: id } },
      populate: {
        banner: {
          populate: "*",
        },
        image: {
          populate: {
            url: "*",
          },
        },
        image2: {
          populate: {
            url: "*",
          },
        },
        ficheTechnique: {
          populate: {
            url: "*",
          },
        },
        pointfort: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        realisation: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        pointreassurance: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        versionImages: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        jetList: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        relatedProducts: {
          populate: "attributes",
        },
        colors: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        cuveColors: {
          populate: {
            cards: { populate: ["image", "image2"], sort: ["order:asc"] },
          },
        },
        seo: {
          populate: "ogimage",
        },
      },
    },
    { encodeValuesOnly: true }
  );
  if (!noLoading) {
    dispatch({ type: "PRODUCTS_LOADING" });
  }

  try {
    let { data } = await API.get("/api/products?" + query);

    dispatch({ type: "FETCH_PRODUCT_ITEM", payload: data.data[0] });
    dispatch({ type: "LIST_DONE_LOADING" });
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};

const createList = async (defaultObject, name, resolution) => {
  let cardFR = await API.post("/api/cards", {
    data: defaultObject,
  });

  let defaultListFR = {
    name: `Product ${name} list`,
    resolution: resolution,

    cards: [cardFR.data.data.id],
  };

  let listFR = await API.post("/api/lists", {
    data: defaultListFR,
  });

  return { listFR };
};

export const addProduct = () => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  API.defaults.params = {};
  let defaultImage = null;

  dispatch({ type: "PRODUCTS_LOADING" });
  try {
    let image = await API.get("api/upload/files");
    defaultImage = image.data[0].id;
  } catch (error) {
    dispatch(handleError("Network error", 1));

    console.log(error);
  }

  try {
    if (!defaultImage) {
      return dispatch(
        handleError("Please import at least one image to proceed", 1)
      );
    }
    let pointfort = {
      name: `default product strong point card`,
      title: `Default strong point title`,
      description: `Default strong point description`,
      content: `Default strong point content`,
      image: defaultImage,
      image2: defaultImage,
    };

    let pointReassurance = {
      name: `default product reassurance point card`,
      title: `Default reassurance point title`,
      description: `Default reassurance point description`,
      content: `Default reassurance point content`,
      image: defaultImage,
      image2: defaultImage,
    };

    let realisation = {
      name: `default product realizations card`,
      image: defaultImage,
    };

    let histoireTherapy = {
      name: `default product therapy history card`,
      title: "therapy history title",
      description: `Default therapy history description`,
      image: defaultImage,
    };

    let versionImages = {
      name: `image list card`,
      image: defaultImage,
    };

    let listPointFort = await createList(pointfort, "point fort", "icone");

    let listPointReassurance = await createList(
      pointReassurance,
      "point de réassurance",
      "icone"
    );

    let nosRealisations = await createList(
      realisation,
      "nos réalisations",
      "carré"
    );

    let jetList = await createList(
      histoireTherapy,
      "histoire de thérapie",
      "carré"
    );

    let imagesProduits = await createList(
      versionImages,
      "autre images",
      "carré"
    );

    const defaultjetSection = {
      name: "Product therapy history section ",
      image: [defaultImage],
      resolution: "Video",
      list: jetList.listFR.data.data.id,
    };

    let jetSection = await API.post("/api/sections", {
      data: defaultjetSection,
    });

    let couleurHabillage = {
      name: "Product Color",
      image: defaultImage,
    };

    let listCouleurHabillage = await createList(
      couleurHabillage,
      "couleur habillage"
    );

    let couleurCuve = {
      name: "Product Color",
      image: defaultImage,
    };

    let listCouleurCuve = await createList(couleurCuve, "couleur cuve");

    let defaultSEOFR = {
      title: "default product SEO title",
      description: "default product SEO description",
      ogimage: defaultImage,
    };

    let SEOfr = await API.post("/api/seos", {
      data: defaultSEOFR,
    });

    const defaultBanner = {
      name: "Product Banner ",
      title: "default banner",
      subtitle: "default subtitle",
      image: [defaultImage],
    };

    let bannerfr = await API.post("/api/sections", {
      data: defaultBanner,
    });

    let defaultProductFr = {
      name: "Default Product",
      type: 0,
      collection: 0,
      places: 1,
      onstock: 0,
      price: "10 000",
      ficheTechnique: 444,
      banner: bannerfr.data.data.id,
      jetCard: jetSection.data.data.id,
      pointfort: listPointFort.listFR.data.data.id,
      colors: listCouleurHabillage.listFR.data.data.id,
      cuveColors: listCouleurCuve.listFR.data.data.id,
      pointreassurance: listPointReassurance.listFR.data.data.id,
      realisation: nosRealisations.listFR.data.data.id,
      versionImages: imagesProduits.listFR.data.data.id,
      image: defaultImage,
      image2: defaultImage,
      seo: SEOfr.data.data.id,
    };

    const productFr = await API.post("/api/products", {
      data: defaultProductFr,
    });

    await API.put(`/api/products/${productFr.data.data.id}`, {
      data: {
        path: productUrlRewrite(
          productFr.data.data.id,
          productFr.data.data.attributes.name
        ),
      },
    });

    dispatch(
      handleInfo("Default product added (you can edit it) ", 1)
    );
    dispatch(getAllProducts());
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};

export const updateProduct = (id, product) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;

  dispatch({ type: "PRODUCTS_LOADING" });
  try {
    await API.put(`/api/products/${id}`, { data: product });
    dispatch(handleInfo("Product modified", 1));
    dispatch(getProductItem(id));
  } catch (error) {
    dispatch(handleError("Network error", 1));
    console.log(error);
  }
};
